import React from 'react';
import ContactReceptionImage1 from '../../../assets/ContactImage1.jpg';
import "./ContactReceptionImage1.css";

const ContactReceptionImage = () => {
    return (
      <div className="reception-snaithe-2-parallax-container">
        <img className="reception-snaithe-2-parallax-image" src={ContactReceptionImage1} alt="Reception of Snaithe" />
      </div>
    );
  };
  
  export default ContactReceptionImage;